import { render } from "./NotifyUsers.vue?vue&type=template&id=7a00d299&scoped=true"
import script from "./NotifyUsers.vue?vue&type=script&lang=js"
export * from "./NotifyUsers.vue?vue&type=script&lang=js"

import "./NotifyUsers.vue?vue&type=style&index=0&id=7a00d299&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a00d299"]])

export default __exports__